import { render, staticRenderFns } from "./NonAgentNovelListItem.vue?vue&type=template&id=47a96456&scoped=true"
import script from "./NonAgentNovelListItem.vue?vue&type=script&lang=ts"
export * from "./NonAgentNovelListItem.vue?vue&type=script&lang=ts"
import style0 from "./NonAgentNovelListItem.vue?vue&type=style&index=0&id=47a96456&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a96456",
  null
  
)

export default component.exports